import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import { PageHeader } from '@/shared/ui';
import { MANUAL_NODES } from '@/shared/config/manual';

import type { useServiceUsers } from '../model';
import { ServiceStats, ActivityChart, TopListsGrid } from './components';

interface ServiceUsersPageProps {
  /** Owned by `ServiceUsersWithFilters`, which also publishes it to the header. */
  serviceUsers: ReturnType<typeof useServiceUsers>;
}

export function ServiceUsersPage({ serviceUsers }: ServiceUsersPageProps) {
  const { t } = useTranslation();
  const { data, formattedStats, isFetching, error, urlState } = serviceUsers;

  if (error) {
    return (
      <div>
        <Card className="p-4 md:p-6">
          <p className="text-destructive">Error loading service users data</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-4 md:space-y-6">
      <PageHeader title={t('welcome.serviceusers.label')} helpTarget={MANUAL_NODES.SERVICE_USERS}>
        <ServiceStats stats={formattedStats} isLoading={isFetching} />
      </PageHeader>

      <ActivityChart data={data?.serviceUsers} metric={urlState.metric} isLoading={isFetching} />
      <TopListsGrid topProducts={data?.topProducts} topServiceUsers={data?.topServiceUsers} isLoading={isFetching} />
    </div>
  );
}
